import Api from '@/common/api';

export async function requestListApi({ params }) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('get', '/outbound/api/ticket/staff/list', {
    params: { ...params },
  });
  const { data, ...rest } = response;
  return {
    data,
    metadata: {
      ...rest,
    },
  };
}

export async function requestDetailApi(id) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('get', `/outbound/api/ticket/${id}`);
  const { ticketData } = response;
  return ticketData;
}

export async function requestAddTicketResponseApi({ ticketId, staffId, email, body, status }) {
  const api = Api.getAPiOsTicket();
  return await api.request('post', `/outbound/api/ticket/${ticketId}/response`, {
    staff_id: staffId,
    email,
    body,
    status,
  });
}
